<app-data-table mainTitle="Cadastro ECD"
            singleTitle="escrituração"
            routerPath="/cad-ecd"
            entityPath="/cadecd"
            keyField="id"
            [entity]="cadEcd"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>